import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
import { Form } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { DESIGNS, PopupDesign } from "./PopupDesigns";
import { IMPLEMENTED_TRIGGERS } from "./triggers";

const TRIGGERS = IMPLEMENTED_TRIGGERS.map((t) => t.key);

const CreatePopupOffer = (props) => {
  const { open, onClose, editData = {}, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);

  const [name, setName] = useState("");
  const [template, setTemplate] = useState("hero");
  const [triggerEvent, setTriggerEvent] = useState("session_start");
  const [priority, setPriority] = useState(1);
  const [active, setActive] = useState(true);
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");
  const [maxPerDay, setMaxPerDay] = useState(1);
  // the only display the admin sets — everything else lives in the selected design component
  const [ctaText, setCtaText] = useState("");
  const [ctaLink, setCtaLink] = useState("");
  // optional middle CONTENT (stored as the offer's `content` JSON; the design component renders it)
  const [sub, setSub] = useState("");
  const [valueBig, setValueBig] = useState("");
  const [valueLabel, setValueLabel] = useState("");
  const [items, setItems] = useState("");        // one per line
  const [timer, setTimer] = useState(false);
  const [finePrint, setFinePrint] = useState("");
  // reward (optional): instant = button credits on click; on_purchase = credits after buying the package
  const [rewardMode, setRewardMode] = useState("none");
  const [rewardType, setRewardType] = useState("SC");
  const [rewardSc, setRewardSc] = useState("");
  const [rewardMultiplier, setRewardMultiplier] = useState(1);
  const [rewardGc, setRewardGc] = useState("");
  const [rewardRafPercent, setRewardRafPercent] = useState("");
  const [gameSearch, setGameSearch] = useState("");
  const [gameOptions, setGameOptions] = useState([]);
  const [rewardGame, setRewardGame] = useState(null);      // {game_id, game_name, freeCounts, betSize}
  const [rewardSpinCount, setRewardSpinCount] = useState("");
  const [rewardSpinValue, setRewardSpinValue] = useState(""); // SC per spin (e.g. 0.1)
  const [packageId, setPackageId] = useState("");
  const [packages, setPackages] = useState([]);
  const [boosterPackageId, setBoosterPackageId] = useState("");
  const [boosterPackages, setBoosterPackages] = useState([]);

  // search free-spin games the same way the user Free Spins section does
  useEffect(() => {
    if (!gameSearch || gameSearch.length < 2) { setGameOptions([]); return; }
    const t = setTimeout(async () => {
      try {
        const res = await getAllData(`${endPoints.api.SEARCH_FREESPIN_GAMES}/${encodeURIComponent(gameSearch)}`);
        if (res?.status === "success") setGameOptions(res?.data || []);
      } catch (e) { console.error(e); }
    }, 500);
    return () => clearTimeout(t);
  }, [gameSearch]);

  // instant (direct) reward can only ever be claimed once — lock the cap so it can't be re-shown/re-claimed
  useEffect(() => {
    if (rewardMode === "instant") setMaxPerDay(1);
  }, [rewardMode]);

  // packages for the on_purchase gate and the no-reward package-only flow
  useEffect(() => {
    if (rewardMode === "instant" || packages.length > 0) return;
    (async () => {
      try {
        const res = await getAllData(`${endPoints.api.GET_PACKAGE}`);
        if (res?.status === "success") setPackages(res?.data || []);
      } catch (e) { console.error(e); }
    })();
  }, [rewardMode]);

  // booster packages for the BOOSTER reward type = coin packages flagged isBoost
  useEffect(() => {
    if (rewardType !== "BOOSTER" || boosterPackages.length > 0) return;
    (async () => {
      try {
        const res = await getAllData(`${endPoints.api.GET_PACKAGE}`);
        if (res?.status === "success") setBoosterPackages((res?.data || []).filter((p) => p?.isBoost));
      } catch (e) { console.error(e); }
    })();
  }, [rewardType]);

  // current date-time in the <input type=datetime-local> format — literal digits, no timezone
  // conversion (same convention as every other date field in this app, e.g. Casino/Promo)
  const nowLocal = () => new Date().toISOString().slice(0, 16);

  useEffect(() => {
    if (!open) return;
    const e = editData || {};
    const has = e && Object.keys(e).length > 0;
    setName(has ? e.name || "" : "");
    setTemplate(has ? e.template || "hero" : "hero");
    setTriggerEvent(has ? e.triggerEvent || e.trigger_event || "session_start" : "session_start");
    setPriority(has ? e.priority ?? 1 : 1);
    setActive(has ? !!(e.active ?? true) : true);
    setActiveFrom(has ? e.activeFrom || e.active_from || "" : nowLocal()); // new offers start now (never historical)
    setActiveTo(has ? e.activeTo || e.active_to || "" : "");
    setMaxPerDay(has ? e.maxPerDay ?? e.max_per_day ?? 1 : 1);
    setCtaText(has ? e.ctaText || e.cta_text || "" : "");
    setCtaLink(has ? e.ctaLink || e.cta_link || "" : "");
    const ct = (() => { try { return e.content ? (typeof e.content === "string" ? JSON.parse(e.content) : e.content) : {}; } catch { return {}; } })();
    setSub(has ? ct.sub || "" : "");
    setValueBig(has ? ct.value || "" : "");
    setValueLabel(has ? ct.valueLabel || "" : "");
    setItems(has && Array.isArray(ct.items) ? ct.items.join("\n") : "");
    setTimer(has ? !!ct.timer : false);
    setFinePrint(has ? ct.finePrint || "" : "");
    setRewardMode(has ? (e.rewardType === "BOOSTER" || e.rewardType === "WOF" || e.rewardType === "WOF_RESET" ? "instant" : e.rewardMode || "none") : "none");
    setRewardType(has ? (e.rewardType === "WOF_RESET" ? "WOF" : e.rewardType || "SC") : "SC");
    setRewardSc(has && e.rewardSc ? String(e.rewardSc) : "");
    setRewardMultiplier(has ? e.rewardMultiplier || 1 : 1);
    setRewardGc(has && e.rewardGc ? String(e.rewardGc) : "");
    setRewardRafPercent(has && e.rewardRafPercent ? String(e.rewardRafPercent) : "");
    setRewardSpinCount(has && e.rewardSpinCount ? String(e.rewardSpinCount) : "");
    setRewardSpinValue(has && e.rewardSpinValue ? String(e.rewardSpinValue / 100) : "");
    setRewardGame(has && e.rewardGameId ? { game_id: e.rewardGameId, game_name: e.rewardGameName, freeCounts: [e.rewardSpinCount], betSize: [e.rewardSpinValue / 100] } : null);
    setGameSearch(has ? e.rewardGameName || "" : "");
    setPackageId(has && e.packageId ? String(e.packageId) : "");
    setBoosterPackageId(has && e.boosterPackageId ? String(e.boosterPackageId) : "");
  }, [editData, open]);

  // on edit, when the offer doesn't carry the package ids, resolve them from the saved buy-coins ctaLink
  useEffect(() => {
    if (!open) return;
    const e = editData || {};
    if (e.packageId || e.boosterPackageId) return;
    const m = /[?&]packageId=([^&]+)/.exec(e.ctaLink || e.cta_link || "");
    if (!m) return;
    if (e.rewardType === "BOOSTER") {
      const p = (boosterPackages || []).find((x) => String(x?.packageId) === m[1]);
      if (p) setBoosterPackageId(String(p.id));
    } else {
      const p = (packages || []).find((x) => String(x?.packageId) === m[1]);
      if (p) setPackageId(String(p.id));
    }
  }, [open, editData, packages, boosterPackages]);

  // content boxes the selected design actually uses (drives the form + what we save)
  const designFields = (DESIGNS.find((d) => d.key === template)?.fields) || [];

  const handleOk = () => {
    if (!name) { ErrorToast("Enter an offer name"); return; }
    if (!template) { ErrorToast("Pick a design"); return; }
    if (!triggerEvent) { ErrorToast("Select a trigger"); return; }
    if (!ctaText) { ErrorToast("Enter the button text"); return; }
    const pr = Number(priority);
    if (isNaN(pr) || pr < 1) { ErrorToast("Priority must be 1 or more (1 = highest)"); return; }
    if (activeFrom && activeTo && new Date(activeTo) <= new Date(activeFrom)) { ErrorToast("Active-to must be after active-from"); return; }
    if (rewardMode === "instant" && Number(maxPerDay) > 1) { ErrorToast("Direct reward offers can only be shown/claimed once — Max shows must be 1"); return; }

    // reward validation
    if (rewardMode !== "none") {
      if (rewardType === "SC" && !(Number(rewardSc) > 0)) { ErrorToast("Enter the SC amount"); return; }
      if (rewardType === "GC" && !(Number(rewardGc) > 0)) { ErrorToast("Enter the GC amount"); return; }
      if (rewardType === "FREE_SPIN" && (!rewardGame?.game_id || !rewardSpinCount || !rewardSpinValue)) { ErrorToast("Select game, spin count and spin value"); return; }
      if (rewardType === "RAF_BOOST" && !(Number(rewardRafPercent) > 0)) { ErrorToast("Enter the RAF boost %"); return; }
      if (rewardType === "BOOSTER" && !boosterPackageId) { ErrorToast("Select the booster package"); return; }
      if (rewardMode === "on_purchase" && rewardType !== "BOOSTER" && !packageId) { ErrorToast("Select the package that unlocks the reward"); return; }
    }

    // optional middle content -> the offer's `content` JSON (layout/styling stays in the design)
    const itemList = items.split("\n").map((s) => s.trim()).filter(Boolean);
    const content = {};
    if (name) content.headline = name;
    if (designFields.includes("sub") && sub) content.sub = sub;
    if (designFields.includes("value") && valueBig) content.value = valueBig;
    if (designFields.includes("valueLabel") && valueLabel) content.valueLabel = valueLabel;
    if (designFields.includes("items") && itemList.length) content.items = itemList;
    if (designFields.includes("timer") && timer) content.timer = true;
    if (designFields.includes("finePrint") && finePrint) content.finePrint = finePrint;

    // package picked -> point the CTA at the same buy-coins link the email-package flow uses
    // (long packageId, like fetchEmailurl) so the player side opens the buy popup with that package
    const buyPkg = rewardMode !== "none" && rewardType === "BOOSTER"
      ? (boosterPackages || []).find((p) => String(p?.id) === String(boosterPackageId))
      : rewardMode !== "instant"
      ? (packages || []).find((p) => String(p?.id) === String(packageId))
      : null;

    const payload = {
      name,
      template,              // <- the selected design key the player renders
      triggerEvent,
      priority: pr,
      active: !!active,
      activeFrom: activeFrom || null,
      activeTo: activeTo || null,
      maxPerDay: rewardMode === "instant" ? 1 : Number(maxPerDay) || 1,
      cooldownMinutes: 0,
      rgGated: true,
      ctaText,
      ctaLink: buyPkg?.packageId
        ? `/buy-coins?packageId=${buyPkg.packageId}&segment=N1`
        : /\/buy-coins\?packageId=/.test(ctaLink || "") ? null : ctaLink || null,
      content: Object.keys(content).length ? JSON.stringify(content) : null,
      rewardMode: rewardMode === "none" ? null : rewardMode,
      rewardType: rewardMode === "none" ? null : rewardType,
      rewardSc: rewardType === "SC" && rewardMode !== "none" ? Number(rewardSc) : 0,
      rewardMultiplier: rewardType === "SC" && rewardMode !== "none" ? Number(rewardMultiplier) || 1 : 1,
      rewardGc: rewardType === "GC" && rewardMode !== "none" ? Number(rewardGc) : 0,
      rewardSpinCount: rewardType === "FREE_SPIN" && rewardMode !== "none" ? Number(rewardSpinCount) : 0,
      rewardSpinValue: rewardType === "FREE_SPIN" && rewardMode !== "none" ? Math.round(Number(rewardSpinValue) * 100) : 0,
      rewardGameId: rewardType === "FREE_SPIN" && rewardMode !== "none" ? rewardGame?.game_id || null : null,
      rewardGameName: rewardType === "FREE_SPIN" && rewardMode !== "none" ? rewardGame?.game_name || null : null,
      rewardRafPercent: rewardType === "RAF_BOOST" && rewardMode !== "none" ? Number(rewardRafPercent) : 0,
      boosterPackageId: rewardType === "BOOSTER" && rewardMode !== "none" && boosterPackageId ? Number(boosterPackageId) : null,
      packageId: rewardMode !== "instant" && !(rewardMode !== "none" && rewardType === "BOOSTER") && packageId ? Number(packageId) : null,
    };
    if (editData?.id) payload.id = editData.id;

    const url = editData?.id ? endPoints.api.POPUP_OFFER_UPDATE : endPoints.api.POPUP_OFFER_ADD;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status === "success") { SuccesToast(response?.data?.message || "Pop-up offer saved"); onClose(); }
        else ErrorToast(response?.data?.message || "Failed to save pop-up offer");
      })
      .catch((error) => { setIsLoading(false); console.error(error); ErrorToast("Failed to save pop-up offer"); });
  };

  const isEdit = !!editData?.id;
  const fc = { width: "100%", marginTop: "18px" };

  return (
    <Dialog maxWidth="md" fullWidth open={open} {...other}>
      <DialogTitle sx={{ pr: 6 }}>
        {editData?.id ? "Edit" : "Create"} Pop-up Offer
        <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8, color: "#64607a" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        {/* ----- pick a design (preview-driven) ----- */}
        <Form.Label style={{ fontWeight: "bold", marginTop: 4 }}>{isEdit ? "Design (locked — can't change on edit)" : "Choose a design *"}</Form.Label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
          {(isEdit ? DESIGNS.filter((d) => d.key === template) : DESIGNS).map((d) => {
            const on = template === d.key;
            return (
              <div key={d.key} onClick={isEdit ? undefined : () => setTemplate(d.key)}
                style={{ cursor: isEdit ? "default" : "pointer", width: 150, padding: "10px 12px", borderRadius: 8, border: on ? "2px solid #5B21B6" : "1px solid #ddd", background: on ? "#f3f0fb" : "#fff" }}>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{d.label}</div>
                <div style={{ fontSize: 11, color: "#777" }}>{d.desc}</div>
              </div>
            );
          })}
        </div>

        {/* ----- live preview of the selected design ----- */}
        <div style={{ background: "radial-gradient(120% 90% at 50% 0%,#2a2350,#140f24)", borderRadius: 14, padding: 24, display: "grid", placeItems: "center", minHeight: 240 }}>
          <PopupDesign design={template} ctaText={ctaText || "Button"} endsAt={activeTo} content={{
            headline: name || "Your offer",
            sub,
            value: valueBig,
            valueLabel,
            items: items.split("\n").map((s) => s.trim()).filter(Boolean),
            timer,
            finePrint,
          }} />
        </div>

        <FormControl style={fc}>
          <TextField label="Offer name *" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
        </FormControl>

        {/* ----- CTA (the only display fields) ----- */}
        <FormControl style={fc}>
          <TextField label="Button text *" variant="outlined" value={ctaText} onChange={(e) => setCtaText(e.target.value)} />
        </FormControl>
        {/* <FormControl style={fc}>
          <TextField label="Button link (optional — page to open)" variant="outlined" value={ctaLink} onChange={(e) => setCtaLink(e.target.value)} />
        </FormControl> */}

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Content (optional — fills the design; headline uses the offer name)</Form.Label>
        {designFields.includes("sub") && (
          <FormControl style={fc}>
            <TextField label="Sub-text" variant="outlined" value={sub} onChange={(e) => setSub(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("value") && (
          <FormControl style={fc}>
            <TextField label='Value headline (e.g. "+150%")' variant="outlined" value={valueBig} onChange={(e) => setValueBig(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("valueLabel") && (
          <FormControl style={fc}>
            <TextField label='Value label (e.g. "bonus on pack 1")' variant="outlined" value={valueLabel} onChange={(e) => setValueLabel(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("items") && (
          <FormControl style={fc}>
            <TextField label="Items (one per line)" multiline minRows={2} variant="outlined" value={items} onChange={(e) => setItems(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("finePrint") && (
          <FormControl style={fc}>
            <TextField label="Fine print" variant="outlined" value={finePrint} onChange={(e) => setFinePrint(e.target.value)} />
          </FormControl>
        )}
        {designFields.includes("timer") && (
          <FormControlLabel style={{ marginTop: 8, display: "block" }}
            control={<Switch checked={!!timer} onChange={() => setTimer(!timer)} />}
            label="Show countdown timer" />
        )}

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Reward (optional)</Form.Label>
        <FormControl style={fc}>
          <TextField select label="Reward mode" value={rewardMode} onChange={(e) => {
            setRewardMode(e.target.value);
            if (e.target.value === "on_purchase" && (rewardType === "BOOSTER" || rewardType === "WOF")) setRewardType("SC");
          }}>
            <MenuItem value="none">No reward</MenuItem>
            <MenuItem value="instant">Reward only — button credits instantly</MenuItem>
            <MenuItem value="on_purchase">Reward after package buy — credits when the package is purchased</MenuItem>
          </TextField>
        </FormControl>
        {rewardMode === "none" && (
          <FormControl style={fc}>
            <TextField select label="Package to buy (optional — no reward, user just buys it)" value={packageId} onChange={(e) => setPackageId(e.target.value)}>
              <MenuItem value="">None</MenuItem>
              {(packages || []).map((p) => <MenuItem key={p?.id} value={String(p?.id)}>{`$${p?.purchase_price ?? "?"} — ${p?.goldcoins ?? 0} GC / ${p?.sagacoins ?? 0} SC`}</MenuItem>)}
            </TextField>
          </FormControl>
        )}
        {rewardMode !== "none" && (
          <>
            <FormControl style={fc}>
              <TextField select label="Reward type" value={rewardType} onChange={(e) => setRewardType(e.target.value)}>
                <MenuItem value="SC">SC (Saga Coins)</MenuItem>
                <MenuItem value="GC">GC (Gold Coins)</MenuItem>
                <MenuItem value="FREE_SPIN">Free Spins</MenuItem>
                <MenuItem value="RAF_BOOST">Refer-a-Friend — earn more %</MenuItem>
                {rewardMode === "instant" && <MenuItem value="WOF">Wheel of Fortune</MenuItem>}
                {rewardMode === "instant" && <MenuItem value="BOOSTER">Booster — buy the boost package</MenuItem>}
              </TextField>
            </FormControl>
            {rewardType === "SC" && (
              <>
                <FormControl style={fc}>
                  <TextField label="SC amount" type="number" inputProps={{ min: 0, step: "0.1" }} variant="outlined" value={rewardSc} onChange={(e) => setRewardSc(e.target.value)} />
                </FormControl>
                <FormControl style={fc}>
                  <TextField select label="Multiplier (playthrough)" value={rewardMultiplier} onChange={(e) => setRewardMultiplier(e.target.value)}>
                    {[1, 2, 3, 4, 5].map((m) => <MenuItem key={m} value={m}>{m}x</MenuItem>)}
                  </TextField>
                </FormControl>
              </>
            )}
            {rewardType === "GC" && (
              <FormControl style={fc}>
                <TextField label="GC amount" type="number" inputProps={{ min: 0 }} variant="outlined" value={rewardGc} onChange={(e) => setRewardGc(e.target.value)} />
              </FormControl>
            )}
            {rewardType === "FREE_SPIN" && (
              <>
                <FormControl style={fc}>
                  <Autocomplete
                    options={gameOptions}
                    getOptionLabel={(g) => g?.game_name || ""}
                    isOptionEqualToValue={(o, v) => o?.game_id === v?.game_id}
                    filterOptions={(x) => x}
                    value={rewardGame}
                    inputValue={gameSearch}
                    onInputChange={(e, val, reason) => {
                      setGameSearch(val);
                      if (reason === "input") { setRewardGame(null); setRewardSpinCount(""); setRewardSpinValue(""); }
                    }}
                    onChange={(e, g) => {
                      setRewardGame(g);
                      if (!g) { setRewardSpinCount(""); setRewardSpinValue(""); }
                    }}
                    renderInput={(params) => <TextField {...params} label="Game (type 2+ letters to search)" variant="outlined" />}
                  />
                </FormControl>
                {rewardGame && (
                  <>
                    <FormControl style={fc}>
                      <TextField select label="Spin count (game-allowed)" value={rewardSpinCount} onChange={(e) => setRewardSpinCount(e.target.value)}>
                        {(rewardGame?.freeCounts || []).map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                      </TextField>
                    </FormControl>
                    <FormControl style={fc}>
                      <TextField select label="Spin value (SC, game-allowed)" value={rewardSpinValue} onChange={(e) => setRewardSpinValue(e.target.value)}>
                        {(rewardGame?.betSize || []).map((b) => <MenuItem key={b} value={b}>{b}</MenuItem>)}
                      </TextField>
                    </FormControl>
                  </>
                )}
              </>
            )}
            {rewardType === "RAF_BOOST" && (
              <FormControl style={fc}>
                <TextField label="Extra % on next referral bonus" type="number" inputProps={{ min: 1, max: 500 }} variant="outlined" value={rewardRafPercent} onChange={(e) => setRewardRafPercent(e.target.value)} />
              </FormControl>
            )}
            {rewardType === "BOOSTER" && (
              <FormControl style={fc}>
                <TextField select label="Booster package *" value={boosterPackageId} onChange={(e) => setBoosterPackageId(e.target.value)}>
                  {(boosterPackages || []).map((p) => <MenuItem key={p?.id} value={String(p?.id)}>{`$${p?.purchase_price ?? "?"} — ${p?.goldcoins ?? 0} GC / ${p?.sagacoins ?? 0} SC${p?.boostValue ? ` (+${p.boostValue}% boost)` : ""}`}</MenuItem>)}
                </TextField>
              </FormControl>
            )}
            {rewardMode === "on_purchase" && rewardType !== "BOOSTER" && (
              <FormControl style={fc}>
                <TextField select label="Package that unlocks the reward *" value={packageId} onChange={(e) => setPackageId(e.target.value)}>
                  {(packages || []).map((p) => <MenuItem key={p?.id} value={String(p?.id)}>{`$${p?.purchase_price ?? "?"} — ${p?.goldcoins ?? 0} GC / ${p?.sagacoins ?? 0} SC`}</MenuItem>)}
                </TextField>
              </FormControl>
            )}
          </>
        )}

        <hr />
        <Form.Label style={{ fontWeight: "bold" }}>Targeting & rules</Form.Label>
        <FormControl style={fc}>
          <TextField select label="Trigger *" value={triggerEvent} onChange={(e) => setTriggerEvent(e.target.value)}>
            {TRIGGERS.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
          </TextField>
        </FormControl>
        <FormControl style={fc}>
          <TextField label="Priority (lower wins — 1 = first)" type="number" inputProps={{ min: 1 }} variant="outlined" value={priority} onChange={(e) => setPriority(e.target.value)} />
        </FormControl>

        {/* ----- hidden for now (re-enable when needed) -----
        <FormControl style={fc}>
          <TextField label="Package ID (coin package)" type="number" variant="outlined" value={packageId} onChange={(e) => setPackageId(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <TextField label="Bonus ID (optional)" type="number" variant="outlined" value={bonusId} onChange={(e) => setBonusId(e.target.value)} />
        </FormControl>
        ------------------------------------------------------- */}

        <FormControl style={fc}>
          <label>Active from (auto — starts now; set later to schedule)</label>
          <TextField type="datetime-local" variant="outlined" value={activeFrom} onChange={(e) => setActiveFrom(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <label>Active to (blank = runs until turned off)</label>
          <TextField type="datetime-local" variant="outlined" value={activeTo} onChange={(e) => setActiveTo(e.target.value)} />
        </FormControl>
        <FormControl style={fc}>
          <TextField label="Max shows (per user — total, ever)" type="number" inputProps={{ min: 1, max: rewardMode === "instant" ? 1 : undefined }}
            disabled={rewardMode === "instant"} variant="outlined" value={maxPerDay}
            helperText={rewardMode === "instant" ? "Locked to 1 — a direct reward can only ever be claimed once" : ""}
            onChange={(e) => setMaxPerDay(e.target.value)} />
        </FormControl>
        <FormControlLabel style={{ marginTop: 4, display: "block" }}
          control={<Switch checked={!!active} onChange={() => setActive(!active)} />}
          label="Active" />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleOk} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePopupOffer;
